import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BestsellerContext = createContext({ ids: new Set() });

export const BestsellerProvider = ({ children }) => {
  const [ids, setIds] = useState(new Set());

  useEffect(() => {
    axios.get(`${API}/products/bestseller-ids`)
      .then(res => setIds(new Set(res.data.ids || [])))
      .catch(() => {});
  }, []);

  return (
    <BestsellerContext.Provider value={{ ids }}>
      {children}
    </BestsellerContext.Provider>
  );
};

export const useBestsellers = () => useContext(BestsellerContext);
